// Puneri Kitchen menu — images cropped from the official menu card (served locally).
// No prices by design: image + name + speciality only.

const P = (n) => `${process.env.PUBLIC_URL || ""}/dishes/${n}.png`;

export const HERO_IMAGES = [
  { url: P("special_veg_thali"), label: "Special Puneri Thali" },
  { url: P("chicken_kolhapuri"), label: "Chicken Kolhapuri" },
  { url: P("vada_pav"), label: "Vada Pav" },
];

export const CATEGORIES = [
  { id: "all", label: "All" },
  { id: "breakfast", label: "Breakfast" },
  { id: "snacks", label: "Snacks" },
  { id: "breads", label: "Breads" },
  { id: "specials", label: "Maharashtrian Specials" },
  { id: "thalis", label: "Thalis" },
  { id: "nonveg", label: "Non-Veg" },
  { id: "desserts", label: "Desserts" },
  { id: "beverages", label: "Beverages" },
];

export const DISHES = [
  // Breakfast
  { name: "Kanda Poha", cat: "breakfast", type: "veg", img: P("kanda_poha"), speciality: "Fluffy flattened rice tempered with onion, mustard & curry leaves." },
  { name: "Batata Poha", cat: "breakfast", type: "veg", img: P("batata_poha"), speciality: "Soft potato poha with a squeeze of lemon & fresh coriander." },
  { name: "Misal Pav", cat: "breakfast", type: "veg", img: P("misal_pav"), speciality: "Spicy sprouted usal crowned with farsan, onion & soft pav." },
  { name: "Sabudana Khichdi", cat: "breakfast", type: "veg", img: P("sabudana_khichdi"), speciality: "Fasting favourite of pearl sago, roasted peanuts & mild green chilli." },
  { name: "Sabudana Vada", cat: "breakfast", type: "veg", img: P("sabudana_vada"), speciality: "Golden crisp sago fritters served with cool peanut chutney." },
  { name: "Thalipeeth with White Butter", cat: "breakfast", type: "veg", img: P("thalipeeth"), speciality: "Rustic multigrain pancake topped with a dollop of white butter." },
  { name: "Upma", cat: "breakfast", type: "veg", img: P("upma"), speciality: "Silky roasted semolina with vegetables & a curry-leaf tadka." },

  // Snacks
  { name: "Vada Pav", cat: "snacks", type: "veg", img: P("vada_pav"), speciality: "The beloved potato vada tucked in pav with dry garlic chutney." },
  { name: "Kothimbir Vadi", cat: "snacks", type: "veg", img: P("kothimbir_vadi"), speciality: "Steamed-then-fried coriander & gram-flour savoury squares." },
  { name: "Batata Vada", cat: "snacks", type: "veg", img: P("batata_vada"), speciality: "Spiced potato dumplings fried to a crisp golden shell." },
  { name: "Onion Bhaji", cat: "snacks", type: "veg", img: P("onion_bhaji"), speciality: "Lacy crisp onion fritters — monsoon comfort in every bite." },
  { name: "Mirchi Bhaji", cat: "snacks", type: "veg", img: P("mirchi_bhaji"), speciality: "Plump green chillies in a crunchy spiced besan coat." },

  // Breads — freshly prepared, soft & homemade
  { name: "Chapati (2 pcs)", cat: "breads", type: "veg", img: P("chapati"), speciality: "Soft, hand-rolled whole-wheat chapatis, made fresh to order." },
  { name: "Bhakari (Jowar)", cat: "breads", type: "veg", img: P("bhakri_jowar"), speciality: "Rustic jowar flatbread, patted by hand & roasted on the tawa." },
  { name: "Bhakari (Bajra) — Seasonal", cat: "breads", type: "veg", img: P("bhakri_bajra"), speciality: "Wholesome pearl-millet bhakari — a warming winter favourite." },
  { name: "Phulka (2 pcs)", cat: "breads", type: "veg", img: P("phulka"), speciality: "Light, airy phulkas puffed straight off the open flame." },
  { name: "Butter Chapati", cat: "breads", type: "veg", img: P("butter_chapati"), speciality: "Warm chapati brushed with home-style white butter." },
  { name: "Butter Phulka", cat: "breads", type: "veg", img: P("butter_phulka"), speciality: "Puffed phulka glistening with a generous dab of butter." },
  { name: "Pav (2 pcs)", cat: "breads", type: "veg", img: P("pav"), speciality: "Soft ladi pav — perfect with misal, usal & bhaji." },
  { name: "Extra Pav (1 pc)", cat: "breads", type: "veg", img: P("extra_pav"), speciality: "An extra soft pav to mop up every last bit of gravy." },

  // Maharashtrian Specials (Veg)
  { name: "Pithla Bhakri", cat: "specials", type: "veg", img: P("pithla_bhakri"), speciality: "Farmhouse gram-flour curry with warm jowar bhakri." },
  { name: "Zunka Bhakri", cat: "specials", type: "veg", img: P("zunka_bhakri"), speciality: "Dry spiced besan crumble — a true Puneri street classic." },
  { name: "Bharli Vangi", cat: "specials", type: "veg", img: P("bharli_vangi"), speciality: "Baby brinjals stuffed with roasted peanut-coconut masala." },
  { name: "Matki Usal", cat: "specials", type: "veg", img: P("matki_usal"), speciality: "Sprouted moth beans simmered in a light goda masala." },
  { name: "Varan Bhaat with Ghee", cat: "specials", type: "veg", img: P("varan_bhaat"), speciality: "Comforting toor dal & rice finished with pure home ghee." },

  // Thalis
  { name: "Regular Veg Thali", cat: "thalis", type: "veg", img: P("regular_veg_thali"), speciality: "Wholesome spread of bhakri, seasonal bhaji, dal, rice & sweet." },
  { name: "Special Puneri Veg Thali", cat: "thalis", type: "veg", img: P("special_veg_thali"), speciality: "Our grand platter of seasonal delicacies, papad & pickle." },
  { name: "Chicken Thali", cat: "thalis", type: "nonveg", img: P("chicken_thali"), speciality: "Chicken Kolhapuri, tambda rassa, bhakris, rice & salad." },
  { name: "Mutton Thali", cat: "thalis", type: "nonveg", img: P("mutton_thali"), speciality: "Mutton rassa, pandhra rassa, bhakris, rice & salad." },

  // Non-Veg Specials
  { name: "Chicken Kolhapuri", cat: "nonveg", type: "nonveg", img: P("chicken_kolhapuri"), speciality: "Fiery Kolhapuri masala chicken with signature tambda tadka." },
  { name: "Chicken Sukka", cat: "nonveg", type: "nonveg", img: P("chicken_sukka"), speciality: "Dry-roasted chicken with fresh coconut & aromatic spices." },
  { name: "Chicken Handi", cat: "nonveg", type: "nonveg", img: P("chicken_handi"), speciality: "Slow-cooked chicken in a rich, smoky handi gravy." },
  { name: "Mutton Rassa", cat: "nonveg", type: "nonveg", img: P("mutton_rassa"), speciality: "Traditional thin, spicy mutton curry — Puneri style." },
  { name: "Mutton Sukka", cat: "nonveg", type: "nonveg", img: P("mutton_sukka"), speciality: "Dry mutton tossed in freshly ground Kolhapuri masala." },
  { name: "Egg Curry", cat: "nonveg", type: "egg", img: P("egg_curry"), speciality: "Home-style egg curry in a robust onion-tomato masala." },

  // Desserts
  { name: "Puran Poli", cat: "desserts", type: "veg", img: P("puran_poli"), speciality: "Sweet lentil-stuffed flatbread served with warm ghee." },
  { name: "Shrikhand", cat: "desserts", type: "veg", img: P("shrikhand"), speciality: "Saffron-cardamom hung curd — silky, rich & festive." },
  { name: "Basundi", cat: "desserts", type: "veg", img: P("basundi"), speciality: "Slow-reduced sweetened milk finished with nuts." },
  { name: "Ukadiche Modak", cat: "desserts", type: "veg", img: P("ukadiche_modak"), speciality: "Steamed rice dumplings filled with jaggery & coconut." },

  // Beverages
  { name: "Solkadhi", cat: "beverages", type: "veg", img: P("solkadhi"), speciality: "Cooling kokum & coconut digestive — a coastal classic." },
  { name: "Masala Chaas", cat: "beverages", type: "veg", img: P("masala_chaas"), speciality: "Spiced buttermilk with cumin, coriander & curry leaf." },
  { name: "Fresh Lime Soda", cat: "beverages", type: "veg", img: P("fresh_lime_soda"), speciality: "Zesty lime refresher — sweet, salted or mixed." },
  { name: "Mineral Water", cat: "beverages", type: "veg", img: P("mineral_water"), speciality: "Chilled packaged drinking water." },
];

export const CHEF_PICKS = [
  "Puneri Misal Pav",
  "Chicken Kolhapuri",
  "Mutton Rassa Thali",
  "Pithla Bhakri",
  "Zunka Bhakri",
  "Puran Poli",
  "Ukadiche Modak",
  "Solkadhi",
];

export const BRAND = {
  name: "Puneri Kitchen",
  tagline: "Authentic Maharashtrian Flavours",
  marathi: "चव पुण्याची, आठवण घरची",
  logo: "https://customer-assets-39nsmqrw.emergentagent.net/job_18b46751-0c01-4270-acd4-55dcc50e7fd4/artifacts/njp2vwlr_WhatsApp%20Image%202026-07-29%20at%2021.36.31.jpeg",
  phone: "+91 7022919654",
  phoneRaw: "917022919654",
  email: "Info@punerikitchen.com",
  emailSupport: "services@punerikitchen.com",
  instagram: "punerikitchenn",
  facebook: "Puneri Kitchen",
  facebookUrl: "https://www.facebook.com/profile.php?id=61592937053471",
  address: "302, Shetty Layout, Garudacharpalya, Bangalore - 560048",
  fssai: "21226188003663",
  interior: "https://images.unsplash.com/photo-1730965804534-eff996ac3249?w=1400&q=80",
};
